<template>
  <!-- Login is its own standalone v-app (no nav shell); everything else gets the app shell. -->
  <router-view v-if="$route.name === 'Login'" />
  <v-app v-else>
    <v-app-bar
      id="abstract-app-bar"
      color="primary"
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>Abstract Images</v-toolbar-title>
      <v-spacer></v-spacer>
      <span id="routeName" class="mr-2">{{ $route.name }}</span>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer">
      <AbstractProgramList />
    </v-navigation-drawer>

    <v-main>
      <router-view />
    </v-main>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      timeout="4000"
    >
      {{ snackbar.text }}
      <template #actions>
        <v-btn variant="text" @click="closeSnackbar">Close</v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<style>
/* Global print rule: hide the app chrome and anything a page marks
   no-print (report filter bars, action buttons) on every screen, not just
   Reports -- nobody printing any screen wants the sidebar/toolbar in the
   output. Unscoped deliberately (App.vue is always mounted).
   .v-application prefix: Vuetify's display utilities (.d-flex etc.) are
   also !important, so a bare .no-print on the same element loses to them. */
@media print {
  #abstract-app-bar,
  .v-navigation-drawer,
  .v-application .no-print {
    display: none !important;
  }
  .v-main {
    padding: 0 !important;
  }
}
</style>

<script>
import { mapState, mapMutations } from 'vuex';
import AbstractProgramList from './components/common/AbstractProgramList.vue';

export default {
  name: 'App',
  components: {
    AbstractProgramList,
  },
  data: () => ({
    drawer: true,
  }),
  computed: {
    ...mapState(['snackbar']),
  },
  watch: {
    // Image Viewer opens fullscreen in its own tab (see
    // AbstractProgramList.vue's target="_blank") specifically to maximize
    // viewing space, so default the drawer closed there instead of open
    // like every other route. `immediate: true` alone isn't enough here --
    // the router's initial navigation resolves asynchronously (routes are
    // lazy `import()`ed), so $route.name is still unset in created(); this
    // watcher re-fires once it actually resolves.
    '$route.name': {
      immediate: true,
      handler(name) {
        if (name === 'ImageViewerPage') this.drawer = false;
      },
    },
  },
  methods: {
    ...mapMutations(['closeSnackbar']),
  },
};
</script>
